(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-order-request"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-b2b-order]').forEach((root) => {
    const quantities = [...root.querySelectorAll('[data-order-quantity]')];
    const countOutput = root.querySelector('[data-order-count]');
    const totalOutput = root.querySelector('[data-order-total]');
    const submitButton = root.querySelector('[data-order-submit]');
    const errorOutput = root.querySelector('[data-order-error]');
    const successOutput = root.querySelector('[data-order-success]');
    const successMessage = root.querySelector('[data-order-success-message]');
    const successMessageBase = successMessage?.textContent || '';
    const form = root.querySelector('[data-order-form]');
    const searchInput = root.querySelector('[data-order-search]');
    const collectionSelect = root.querySelector('[data-order-collection]');
    const noResults = root.querySelector('[data-order-no-results]');
    const currency = root.dataset.currency || 'EUR';
    const money = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency });
    let requestId = crypto.randomUUID();
    let submitting = false;

    const filterProducts = () => {
      const query = searchInput?.value.trim().toLowerCase() || '';
      const collection = collectionSelect?.value || '';
      let visibleCount = 0;

      root.querySelectorAll('[data-order-row]').forEach((row) => {
        const matchesSearch = query === '' || row.dataset.searchText.includes(query);
        const matchesCollection = collection === '' || row.dataset.collectionHandles.includes(`|${collection}|`);
        const shouldHide = !(matchesSearch && matchesCollection);
        row.hidden = shouldHide;
        row.classList.toggle('b2b-order-request__product--hidden', shouldHide);
        row.style.display = shouldHide ? 'none' : '';
        if (!shouldHide) visibleCount += 1;
      });

      if (noResults) noResults.hidden = visibleCount !== 0;
    };

    const navigateToCollection = () => {
      const handle = collectionSelect?.value || '';
      const destination = handle
        ? `${root.dataset.collectionsUrl}/${encodeURIComponent(handle)}?view=b2b`
        : root.dataset.allProductsUrl;
      window.location.assign(destination);
    };

    const update = () => {
      const selected = quantities.filter((input) => Number(input.value) > 0);
      const count = selected.reduce((sum, input) => sum + Number(input.value), 0);
      const total = selected.reduce((sum, input) => sum + Number(input.value) * Number(input.dataset.price), 0) / 100;
      if (countOutput) countOutput.textContent = String(count);
      if (totalOutput) totalOutput.textContent = money.format(total);
      if (submitButton) submitButton.disabled = count === 0 || submitting;
    };

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quantity-step]');
      if (!button) return;
      const input = button.parentElement.querySelector('[data-order-quantity]');
      input.value = String(Math.max(0, Math.min(999, Number(input.value || 0) + Number(button.dataset.quantityStep))));
      update();
    });

    root.addEventListener('input', (event) => {
      if (event.target.matches('[data-order-quantity]')) {
        event.target.value = String(Math.max(0, Math.min(999, Number(event.target.value || 0))));
        update();
      }
      if (event.target.matches('[data-order-search]')) {
        filterProducts();
      }
    });

    collectionSelect?.addEventListener('change', navigateToCollection);

    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const selected = quantities.filter((input) => Number(input.value) > 0);
        if (selected.length === 0) {
          if (errorOutput) {
            errorOutput.textContent = root.dataset.emptyMessage;
            errorOutput.hidden = false;
          }
          return;
        }

        const po = root.querySelector('[data-order-po]')?.value.trim() || '';
        const note = root.querySelector('[data-order-note]')?.value.trim() || '';
        const reference = [po, note].filter(Boolean).join(' — ').slice(0, 100);
        const messages = {
          customer_login_required: root.dataset.loginError,
          b2b_company_required: root.dataset.b2bError,
          product_not_allowed: root.dataset.productError,
          rate_limited: root.dataset.rateLimitError,
        };

        submitting = true;
        if (errorOutput) errorOutput.hidden = true;
        if (successOutput) successOutput.hidden = true;
        if (submitButton) submitButton.textContent = root.dataset.sendingLabel;
        update();

        try {
          const response = await fetch(root.dataset.proxyUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              requestId,
              lines: selected.map((input) => ({
                variantId: input.dataset.variantId,
                quantity: Number(input.value),
              })),
              ...(reference ? { reference } : {}),
            }),
          });
          const result = await response.json();
          if (!response.ok || !result.ok) throw new Error(messages[result.error] || root.dataset.genericError);

          const draftOrderName = result.draftOrder?.name ? ` (${result.draftOrder.name})` : '';
          if (successMessage) successMessage.textContent = `${successMessageBase}${draftOrderName}`;
          if (successOutput) {
            successOutput.hidden = false;
            successOutput.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
          quantities.forEach((input) => { input.value = '0'; });
          requestId = crypto.randomUUID();
        } catch (error) {
          if (errorOutput) {
            errorOutput.textContent = error instanceof Error ? error.message : root.dataset.genericError;
            errorOutput.hidden = false;
          }
        } finally {
          submitting = false;
          if (submitButton) submitButton.textContent = root.dataset.submitLabel;
          update();
        }
      });
    }

    update();
    filterProducts();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-cookie-preferences]');
  if (!button || button.disabled) return;
  const errorMessage = button.parentElement.querySelector('[data-cookie-preferences-error]');
  errorMessage.hidden = true;
  button.disabled = true;
  try {
    if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
      await new Promise(function (resolve, reject) {
        const script = document.createElement('script');
        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
    await window.privacyBanner.showPreferences();
  } catch (error) {
    errorMessage.hidden = false;
  } finally {
    button.disabled = false;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

(() => {
  const selectors = '.ly-custom-0, .ly-custom-798';
  const normalize = text => (text || '').replace(/\s+/g, ' ').trim();
  function update(holder) {
    holder.querySelectorAll('a.ly-languages-switcher-link').forEach(link => {
      const label = normalize(link.textContent) || link.getAttribute('lang') || link.getAttribute('data-language-code');
      if (label && link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
    });
    holder.querySelectorAll('.ly-custom-dropdown-current[role="button"]').forEach(button => {
      const label = normalize(button.textContent);
      if (label && button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    });
  }
  function connect(root) {
    root.querySelectorAll(selectors).forEach(holder => {
      if (holder.dataset.celesteAccessible === 'true') return;
      holder.dataset.celesteAccessible = 'true';
      update(holder);
      new MutationObserver(() => update(holder)).observe(holder, {
        subtree: true, childList: true, characterData: true,
        attributes: true, attributeFilter: ['aria-label', 'lang', 'data-language-code']
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => connect(document), { once: true });
  } else {
    connect(document);
  }
  document.addEventListener('shopify:section:load', event => connect(event.target));
})();


(() => {
  if (customElements.get('cm-region-modal')) return;
  customElements.define('cm-region-modal', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.countrySelect = this.dialog.querySelector('[name="country_code"]');
      this.languageSelect = this.dialog.querySelector('[name="language_code"]');
      this.languages = Array.from(this.languageSelect.options).map(option => ({ value: option.value, label: option.textContent }));
      this.syncLanguages = preferred => {
        const country = this.countrySelect.selectedOptions[0];
        const allowed = JSON.parse(country.dataset.languages || '[]');
        const available = this.languages.filter(language => !allowed.length || allowed.includes(language.value));
        const selected = available.some(language => language.value === preferred) ? preferred : available[0]?.value;
        this.languageSelect.replaceChildren(...available.map(language => new Option(language.label, language.value, language.value === selected, language.value === selected)));
      };
      this.setExpanded = expanded => {
        document.querySelectorAll(`[data-cm-region-open="${CSS.escape(this.dialog.id)}"]`).forEach(trigger => {
          trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
      };
      this.focusableItems = () => Array.from(this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(element => element.getClientRects().length > 0);
      this.syncLanguages(this.languageSelect.dataset.currentLanguage);
      this.preferredLanguageByCountry = { US: 'en', IT: 'it' };
      this.countrySelect.addEventListener('change', () => {
        const preferred = this.preferredLanguageByCountry[this.countrySelect.value] || this.languageSelect.value;
        this.syncLanguages(preferred);
      }, options);
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-cm-region-open]');
        if (!trigger || trigger.dataset.cmRegionOpen !== this.dialog.id) return;
        event.preventDefault();
        this.trigger = trigger;
        this.dialog.querySelector('form').reset();
        this.syncLanguages(this.languageSelect.dataset.currentLanguage);
        if (!this.dialog.open) this.dialog.showModal();
        this.setExpanded(true);
        document.body.classList.add('cm-region-open');
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const items = this.focusableItems();
        if (!items.length) {
          event.preventDefault();
          this.dialog.focus();
          return;
        }
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === first || !this.dialog.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target.closest('[data-cm-region-close]')) this.dialog.close();
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('cm-region-open');
        this.setExpanded(false);
        if (this.trigger && this.trigger.isConnected) this.trigger.focus();
      }, options);
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
      if (this.dialog && this.dialog.open) this.dialog.close();
      if (this.setExpanded) this.setExpanded(false);
      document.body.classList.remove('cm-region-open');
    }
  });
})();


(() => {
  if (window.cmHeaderKeyboardNavigation) return;
  window.cmHeaderKeyboardNavigation = true;
  const triggerSelector = '.dropdown_link[data-dropdown-rel]:not(.cm-mobile-search-toggle):not(.cm-desktop-search-toggle)';
  const panelTriggers = new WeakMap();
  let panelIndex = 0;
  let activeTrigger = null;

  const isOpen = panel => {
    const style = window.getComputedStyle(panel);
    return style.display !== 'none' && style.visibility !== 'hidden';
  };

  const panelFor = trigger => {
    const relation = trigger.dataset.dropdownRel;
    if (!relation) return null;
    const scope = trigger.closest('#header') || trigger.closest('.main-nav__wrapper') || trigger.closest('.header');
    return scope ? scope.querySelector(`[data-dropdown="${CSS.escape(relation)}"]`) : null;
  };

  const ensurePanelId = panel => {
    const duplicateId = panel.id && Array.from(document.querySelectorAll('[id]')).filter(element => element.id === panel.id).length > 1;
    if (panel.id && !duplicateId) return panel.id;
    let id;
    do {
      panelIndex += 1;
      id = `cm-header-dropdown-${panelIndex}`;
    } while (document.getElementById(id));
    panel.id = id;
    return id;
  };

  const focusableItems = panel => Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(element => element.getClientRects().length > 0);

  const syncTrigger = trigger => {
    const panel = panelFor(trigger);
    if (!panel) return;
    trigger.setAttribute('aria-controls', ensurePanelId(panel));
    trigger.setAttribute('aria-expanded', isOpen(panel) ? 'true' : 'false');
    panelTriggers.set(panel, trigger);
  };

  const syncStickyNavigation = () => {
    document.querySelectorAll('.sticky_nav').forEach(navigation => {
        const inactive = !navigation.classList.contains('sticky_nav--stick');
      if (inactive) {
        navigation.setAttribute('inert', '');
        navigation.setAttribute('aria-hidden', 'true');
      } else {
        navigation.removeAttribute('inert');
        navigation.removeAttribute('aria-hidden');
      }
    });
  };

  const syncPromoBannerAccessibility = () => {
    const banners = Array.from(document.querySelectorAll('#shopify-section-header .promo-banner'));
    const isShown = document.body.classList.contains('promo-banner--show');
    const focusWasInside = banners.some(banner => banner.contains(document.activeElement));

    banners.forEach(banner => {
      if (isShown) {
        if (banner.hasAttribute('aria-hidden')) banner.removeAttribute('aria-hidden');
        if (banner.hasAttribute('inert')) banner.removeAttribute('inert');
      } else {
        if (banner.getAttribute('aria-hidden') !== 'true') banner.setAttribute('aria-hidden', 'true');
        if (!banner.hasAttribute('inert')) banner.setAttribute('inert', '');
      }
    });

    if (!isShown && focusWasInside) document.querySelector('.cm-skip-link')?.focus();
  };

  const syncAll = () => {
    document.querySelectorAll(triggerSelector).forEach(syncTrigger);
    syncStickyNavigation();
    syncPromoBannerAccessibility();
  };

  const closePanel = (panel, trigger) => {
    panel.style.display = 'none';
    trigger.classList.remove('active_link');
    trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('is-active');
    if (trigger.classList.contains('mobile_nav')) trigger.querySelector('div')?.classList.remove('open');
    trigger.focus();
    activeTrigger = null;
  };

  document.addEventListener('keydown', event => {
    const trigger = event.target.closest(triggerSelector);
    if (trigger && (event.key === 'Enter' || event.key === ' ')) {
      const panel = panelFor(trigger);
      if (!panel) return;
      event.preventDefault();
      trigger.click();
      requestAnimationFrame(() => {
        syncTrigger(trigger);
        if (isOpen(panel)) {
          activeTrigger = trigger;
          panelTriggers.set(panel, trigger);
        }
      });
      return;
    }

    if (trigger && event.key === 'Tab' && !event.shiftKey) {
      const panel = panelFor(trigger);
      if (!panel || !isOpen(panel)) return;
      const firstItem = focusableItems(panel)[0];
      if (!firstItem) return;
      event.preventDefault();
      activeTrigger = trigger;
      firstItem.focus();
      return;
    }

    const panel = event.target.closest('.dropdown_container');
    if (panel && event.key === 'Tab' && event.shiftKey) {
      const items = focusableItems(panel);
      if (items[0] !== event.target) return;
      const owner = panelTriggers.get(panel) || document.querySelector(`[aria-controls="${CSS.escape(panel.id)}"]`);
      if (!owner) return;
      event.preventDefault();
      owner.focus();
      return;
    }

    if (event.key !== 'Escape') return;
    const openPanel = panel || (activeTrigger ? panelFor(activeTrigger) : null);
    const owner = openPanel ? panelTriggers.get(openPanel) || activeTrigger : null;
    if (openPanel && owner && isOpen(openPanel)) {
      event.preventDefault();
      closePanel(openPanel, owner);
    }
  });

  document.addEventListener('click', event => {
    const trigger = event.target.closest(triggerSelector);
    requestAnimationFrame(() => {
      syncAll();
      if (trigger) {
        const panel = panelFor(trigger);
        if (panel && isOpen(panel)) {
          activeTrigger = trigger;
          panelTriggers.set(panel, trigger);
        }
      }
    });
  });

  document.addEventListener('mouseover', event => {
    const trigger = event.target.closest(triggerSelector);
    if (!trigger) return;
    requestAnimationFrame(() => {
      syncTrigger(trigger);
      const panel = panelFor(trigger);
      if (panel && isOpen(panel)) {
        activeTrigger = trigger;
        panelTriggers.set(panel, trigger);
      }
    });
  });

  const observer = new MutationObserver(syncAll);
  const headerRoot = document.getElementById('shopify-section-header') || document.body;
  observer.observe(headerRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
  const promoBannerObserver = new MutationObserver(syncPromoBannerAccessibility);
  promoBannerObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  syncAll();
})();

(() => {
  if (window.cmMiniCartAccessibility) return;
  window.cmMiniCartAccessibility = true;
  let elementIndex = 0;
  let activeTrigger = null;

  const isVisible = element => {
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  };

  const ensureUniqueId = (element, prefix) => {
    const duplicateId = element.id && Array.from(document.querySelectorAll('[id]')).filter(candidate => candidate.id === element.id).length > 1;
    if (element.id && !duplicateId) return element.id;
    let id;
    do {
      elementIndex += 1;
      id = `${prefix}-${elementIndex}`;
    } while (document.getElementById(id));
    element.id = id;
    return id;
  };

  const syncContainer = container => {
    const trigger = container.querySelector('.mini_cart');
    const panel = container.querySelector('.cart_content');
    if (!trigger || !panel) return;
    const triggerId = ensureUniqueId(trigger, 'cm-mini-cart-trigger');
    const panelId = ensureUniqueId(panel, 'cm-mini-cart-panel');
    const open = isVisible(panel);
    trigger.setAttribute('aria-controls', panelId);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-labelledby', triggerId);
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) activeTrigger = trigger;
  };

  const syncAll = () => document.querySelectorAll('.cart-container').forEach(syncContainer);

  const closeContainer = container => {
    const trigger = container?.querySelector('.mini_cart');
    const closeButton = container?.querySelector('.cart_content__continue-shopping');
    if (!trigger) return;
    if (closeButton) {
      closeButton.click();
    }
    container.classList.remove('active_link');
    document.body.classList.remove('is-active', 'blocked-scroll');
    requestAnimationFrame(() => {
      trigger.focus();
      syncAll();
      activeTrigger = null;
    });
  };

  document.addEventListener('keydown', event => {
    const trigger = event.target.closest('.mini_cart');
    const isSpace = event.key === ' ' || event.key === 'Space' || event.key === 'Spacebar' || event.code === 'Space';
    if (trigger && isSpace) {
      event.preventDefault();
      trigger.click();
      requestAnimationFrame(() => {
        syncAll();
        if (trigger.getAttribute('aria-expanded') === 'true') activeTrigger = trigger;
      });
      return;
    }

    if (event.key !== 'Escape') return;
    const container = event.target.closest('.cart-container') || activeTrigger?.closest('.cart-container');
    const panel = container?.querySelector('.cart_content');
    if (!container || !panel || !isVisible(panel)) return;
    event.preventDefault();
    closeContainer(container);
  }, true);

  document.addEventListener('click', event => {
    const trigger = event.target.closest('.mini_cart');
    const continueButton = event.target.closest('.cart_content__continue-shopping');
    const continueTrigger = continueButton?.closest('.cart-container')?.querySelector('.mini_cart');
    requestAnimationFrame(() => {
      if (continueTrigger) continueTrigger.focus();
      syncAll();
      if (trigger && trigger.getAttribute('aria-expanded') === 'true') activeTrigger = trigger;
      if (continueTrigger) {
        activeTrigger = null;
      }
    });
  });

  const observer = new MutationObserver(syncAll);
  const headerRoot = document.getElementById('shopify-section-header') || document.body;
  observer.observe(headerRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
  syncAll();
})();


  } catch(e) { console.error(e); }
})();
})();
